import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import "./inventory.css";
import { useLocation, useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { fetchUserById } from "../../../store/userMgmt";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigData,
  ConfigDataPredefinedTaskBased,
} from "./configData";
import { deleteRewardDefinitionById, fetchCampaignConfig, fetchCampaigns, fetchDefinitionList, fetchRewards, updateCampaignStatus, updateRewardDefinitionStatus } from "../../../store/campaign";
import { REWARDS_DEFINITION_ADD, REWARDS_DEFINITION_DETAIL, REWARDS_INVENTORY_DETAIL } from "../../../routes";
import { CustomDatePicker } from "../../../components/custom/datepicker";
import DatePicker from "react-datepicker";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import moment from "moment";
import momentTZ from 'moment-timezone';
import { CurrencyNgn } from "@phosphor-icons/react";

export const RewardInventoryListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { searchQuery } = useLocation();
  const query = new URLSearchParams(searchQuery);
  const { campaign_list } = useSelector(
    (state) => state.campaigns
  );
  const [tempData, setTempData] = useState([]);
  const [tempDataPredefinedTaskBased, setTempDataPredefinedTaskBased] = useState([]);

  const [loading, setLoading] = useState([]);
  const [campaignTypeList, setCampaignTypeList] = useState([]);
  const [tab, setTab] = useState("");
  const [tabStatus, setTabStatus] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [showExtend, setShowExtend] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [actionID, setActionID] = useState("");
  const [actionType, setActionType] = useState("");
  const [tempExtendDate, setTempExtendDate] = useState("");

  const userPermissions = getUserPermission();
  const AddPermssion = checkPermission(
    userPermissions,
    "gamifications.create_campaign"
  ) || false;

  const viewPermssion = checkPermission(
    userPermissions,
    "gamifications.access_reward"
  );

  const getData = async (callback) => {
    setLoading(true);

    if (tabStatus === "Predefined Task Based") {
      dispatch(fetchDefinitionList()).then((res) => {
        setLoading(false);

        const formattedData = res.payload.data.map(item => ({
          ...item,
          show_extend: `${item.status != "Expired"}`,
          id: item.pk
        }));

        setTempDataPredefinedTaskBased(formattedData);


      });
    } else {
      dispatch(fetchRewards({ campaign_type: tabStatus })).then((res) => {
        setLoading(false);

        const formattedData = res.payload.data.map(item => ({
          ...item
        }));

        setTempData(formattedData);


      });
    }


  };


  const downloadRequiredData = async (callback) => {
    setLoading(true);
    dispatch(fetchUserById(localStorage.getItem("username"))).then(
      async (result) => {
        dispatch(fetchCampaignConfig()).then((res) => {
          const campaignNames = res.payload.data.campaign_type.map(item => item.name);
          setCampaignTypeList(campaignNames);
          if (campaignNames.length > 0) {
            setTab(campaignNames[0]);
            setTabStatus(campaignNames[0]);
          }
        });
      }
    );
  };

  useEffect(() => {
    downloadRequiredData();
  }, []);

  useEffect(() => {
    getData();
  }, [tabStatus]);

  const RefreshData = () => {
    getData();
  };


  const handleCreateAction = () => {
    navigate(REWARDS_DEFINITION_ADD);
  };


  const iconsTaskBased = [
    ...(AddPermssion ? [{
      buttonName: "+ Add new",
      action: handleCreateAction,
    }] : []),
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    }
  ];

  const icons = [
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    }
  ];


  const onTabChange = (tab) => {
    setTab(tab);
  };



  const handleTableClick = (type, id) => {
    navigate(`${REWARDS_INVENTORY_DETAIL}?id=` + id);

  };



  const handleTableDefinitionClick = (type, id) => {
    if (type === "View Details") {
      navigate(`${REWARDS_DEFINITION_DETAIL}?id=${id}`);
    } else if (type === "Edit") {
      navigate(`${REWARDS_DEFINITION_ADD}?id=${id}`);
    } else if (type === "Delete") {
      setActionID(id);
      setActionType(type);
      if (type === "Delete") {
        setShowDelete(true);
      }
    } else if (type === "Update Status") {
      setActionID(id);
      setActionType(type);
      setShowStatus(true);
      const result = tempDataPredefinedTaskBased.find(item => item.id === id);
      setTempStatus(result.status);
      setCurrentStatus(result.status);
    }
    else if (type === "Extend") {
      setActionID(id);
      setActionType("Extend");
      setShowExtend(true);
      const result = tempDataPredefinedTaskBased.find(item => item.id === id);
      setTempExtendDate(new Date(result.end_date));
    }
  };


  const updateStatus = () => {
    setShowStatus(false);

    let params = { status: tempStatus, id: actionID }

    dispatch(updateRewardDefinitionStatus({ data: params, id: actionID })).then((res) => {
      getData();
    });
  };


  const actionTrigger = () => {
    if (actionType === "Delete") {
      setShowDelete(false);

      dispatch(deleteRewardDefinitionById(actionID)).then((res) => {
        getData();

      });
    }

    if (actionType === "Extend") {
      setShowExtend(false);
      const formattedDate = moment(tempExtendDate).format("YYYY-MM-DD");

      let params = { status: "Extended", id: actionID, "end_date": formattedDate , "end_time" : "23:59" }

      dispatch(updateRewardDefinitionStatus({ data: params, id: actionID })).then((res) => {
        getData();
      });
    }
  };


  const getStatusList = () => {
    const status = ["Active", "Inactive", "Expired", "Extended", "Fully Redeemed"];

    if (currentStatus == "Active" || currentStatus == "Scheduled") {
      return ["Inactive"];
    }
    if (currentStatus == "Expired") {
      return ["Extended"];
    }

    return [];
  }




  return (
    <>
      {viewPermssion ? (
        <div className="container">



          {
            (tabStatus === "Predefined Task Based") ? (
              <TableHeader title={"Rewards Inventory"} icons={iconsTaskBased} />

            ) : (
              <TableHeader title={"Rewards Inventory"} icons={icons} />

            )
          }

          {showExtend && (
            <ShowDialog
              title={"Extend Day"}
              cancelContent={"Cancel"}
              confrimContent={"Submit"}
              children={

                <div className="campaigns-dialog-reason-div">
                  <div>End Date <span style={{ color: "red" }}>*</span></div>
                  <div>

                    <DatePicker
                      dateFormatCalendar="MMMM"
                      className="poll-survey-date-picker"
                      selected={tempExtendDate}
                      dateFormat="dd/MM/yyyy"

                      minDate={new Date()}
                      onChange={(date) => {
                        setTempExtendDate(date);
                      }}
                      customInput={<CustomDatePicker />}
                      withPortal
                    />
                  </div>
                </div>

              }
              cancelbtn={() => setShowExtend(false)}
              confrinbtn={actionTrigger}
            />
          )}

          {showDelete && (
            <ShowDialog
              title={"Please Confirm!"}
              content={"Are you sure you want to delete?"}
              cancelContent={"Cancel"}
              confrimContent={"Delete"}
              cancelbtn={() => setShowDelete(false)}
              confrinbtn={actionTrigger}
            />
          )}

          {showStatus && (
            <ShowDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={getStatusList()}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          {(<div className="inventory_child_box_main_detail_box">
            <div>
              <div className="tabs">
                {campaignTypeList.map((name, index) => (
                  <>
                    <div
                      onClick={() => {
                        onTabChange(name);
                        setTabStatus(name);
                      }}
                      className={`tab ${tab === name ? "isactive" : ""}`}
                    >
                      {name}
                    </div>

                    {index !== campaignTypeList.length - 1 && (
                      <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                    )}
                  </>
                ))}
              </div>
            </div>

            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) :
              (tabStatus === "Predefined Task Based") ? (

                <Reusable_table
                  key="taskbased"
                  header={ConfigDataPredefinedTaskBased}
                  data={tempDataPredefinedTaskBased}
                  pagination={true}
                  calculatePagi={true}
                  pageChangeLoading={false}
                  showRow={true}
                  checkbox={false}
                  //   handleTableClick={handleTableClick}
                  handleAction={handleTableDefinitionClick}
                  maxHeight={""}
                  maxWidth={"calc(100vw - 240px)"}
                />
              ) :
                (
                  <Reusable_table
                    key="nomination"
                    header={ConfigData}
                    data={tempData}
                    pagination={true}
                    calculatePagi={true}
                    pageChangeLoading={false}
                    showRow={true}
                    checkbox={false}
                    //   handleTableClick={handleTableClick}
                    handleAction={handleTableClick}
                    maxHeight={""}
                    maxWidth={"calc(100vw - 240px)"}
                  />
                )}
          </div>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
